import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_CONFIG } from '../../utils/constants';

const SEOMeta = ({ title, description, url, schemas = [], type = 'website' }) => {
    const siteTitle = title || SITE_CONFIG.title;
    const siteDescription = description || SITE_CONFIG.description;
    const siteUrl = url || SITE_CONFIG.url;
    const siteImage = `${window.location.origin}/default-og-image.png`;

    return (
        <Helmet>
            <html lang="en" />
            <title>{siteTitle}</title>
            <meta name="title" content={siteTitle} />
            <meta name="description" content={siteDescription} />
            <link rel="canonical" href={siteUrl} />
            
            <meta property="og:type" content={type} />
            <meta property="og:url" content={siteUrl} />
            <meta property="og:title" content={siteTitle} />
            <meta property="og:description" content={siteDescription} />
            <meta property="og:image" content={siteImage} />
            
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={siteUrl} />
            <meta name="twitter:title" content={siteTitle} />
            <meta name="twitter:description" content={siteDescription} />
            <meta name="twitter:image" content={siteImage} />
            
            {schemas.map((schema, index) => (
                <script key={index} type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            ))}
        </Helmet>
    );
};

export default SEOMeta;
